module.exports = __webpack_public_path__ + "img/homepage-banners-mazda-compliant-lincoln.ab90c053.jpg";